import React from 'react'
import { View, Text } from 'react-native'
import { GREEN, GREY } from '../../utils/colors'

export const ConnInfo = ({hasParceiro}: {hasParceiro: boolean}) => {
    return <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
    <View style={{width: 12, height: 12, borderRadius: 12, backgroundColor: hasParceiro ? GREEN : '#ccc'}}></View>
<Text style={{fontSize: 12, opacity: 0.5, marginLeft: 3}}>{`Parceiro ${hasParceiro ? '' : 'des'}conectado`}</Text>
</View>
}